import { useEffect, useState } from 'react';

import { AlairasGomb } from './AlairasGomb.tsx';
import { api } from '../api.ts';

/**
 * A saját aláírás beállítása. (2026-09-30)
 *
 * Az okmányon a mi oldalunkon a dolgozó neve mellett az aláírása áll. Ezt
 * **egyszer** rajzolja meg, és onnantól minden okmányára rákerül — nem kell
 * a helyszínen újra aláírni.
 *
 * Azért itt van, a Szállítólevél képernyőn, mert a sofőrnek ez az egyetlen
 * képernyő, ahol az okmányaival dolgozik; a Felhasználók képernyőt nem
 * látja. Mindenki csak a sajátját állíthatja.
 */
export function SajatAlairas({
  vanMar,
  onKesz,
  onMegse,
}: {
  vanMar: boolean;
  /** A mentés után — a hívó képernyő frissíti a saját adatait. */
  onKesz: (uzenet: string) => void;
  onMegse: () => void;
}) {
  const [rajz, setRajz] = useState<string | null>(null);
  const [betolt, setBetolt] = useState(true);
  const [hiba, setHiba] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ alairas: string | null }>('/api/sajat/alairas')
      .then((v) => setRajz(v.alairas))
      .catch(() => setRajz(null))
      .finally(() => setBetolt(false));
  }, []);

  async function ment(kep: string | null) {
    try {
      await api.post('/api/sajat/alairas', { alairas: kep });
      onKesz(kep ? 'Az aláírásod elmentve — mostantól minden okmányodra rákerül.' : 'Az aláírásod törölve.');
    } catch (h) {
      setHiba(h instanceof Error ? h.message : 'Az aláírást nem sikerült elmenteni.');
    }
  }

  if (betolt) return <div className="npform">Betöltés…</div>;

  return (
    <div className="npform" style={{ maxWidth: 560, marginTop: 12 }}>
      <h4>Saját aláírás</h4>
      <div className="c" style={{ marginBottom: 10 }}>
        Rajzold ide egyszer az aláírásodat — ujjal vagy egérrel. Ezután minden általad
        kiállított szállítólevélre és átadási okmányra magától rákerül.
      </div>
      {hiba && (
        <div className="uzenet bad" onClick={() => setHiba(null)}>
          {hiba}
        </div>
      )}
      {/* Ugyanaz a külön lap, mint az okmányoknál — egy helyen tanulják meg. */}
      <AlairasGomb
        cimke={vanMar ? 'Saját aláírás (a meglévő felülrajzolható)' : 'Saját aláírás'}
        ertek={rajz}
        onValtozott={setRajz}
      />
      <div className="btns">
        <button className="btn pri sm" disabled={!rajz} onClick={() => void ment(rajz)}>
          Mentés
        </button>
        {vanMar && (
          <button className="btn sm" onClick={() => void ment(null)}>
            Aláírás törlése
          </button>
        )}
        <button className="btn sm" onClick={onMegse}>
          Mégse
        </button>
      </div>
    </div>
  );
}
